import { FC } from "react";
import classNames from "classnames";

import { InputFieldProps } from "./types.ts";

import styles from "./InputField.module.css";



const InputField: FC<InputFieldProps> = ({
  placeholder,
  value,
  errorMessage,
  classNameWrapper,
  classNameError,
  className,
  inputRef,
  label,
  multiline,
  rows,
  rightLabel,
  ...props
}) => {
  const fieldClassName = classNames(styles.input__value, className, errorMessage && [styles.input__error, classNameError]);
  const shared = { value, placeholder, className: fieldClassName };

  return (
    <label className={classNames(styles.input, classNameWrapper)}>
      {(label || rightLabel) && (
        <p className={styles.input__label} style={rightLabel ? { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } : undefined}>
          {label && <span>{label}</span>}
          {rightLabel}
        </p>
      )}
      {multiline ? (
        <textarea {...shared} rows={rows} style={{ resize: 'vertical', minHeight: '12rem' }} {...(props as React.TextareaHTMLAttributes<HTMLTextAreaElement>)} />
      ) : (
        <input {...shared} ref={inputRef} {...props} />
      )}
      {errorMessage && (
        <p className={styles.error}>
          {errorMessage || "Некорректное значение"}
        </p>
      )}
    </label>
  );
};

export default InputField;
